import { createAction, props } from '@ngrx/store';
import { AppointmentEntity } from 'src/app/models/appointment.model';

export const loadUpcomingAppointments = createAction(
  '[Appointment] Load Upcoming Appointments'
);

export const loadUpcomingAppointmentsSuccess = createAction(
  '[Appointment] Load Upcoming Appointments Success',
  props<{ appointments: AppointmentEntity[] }>()
);

export const loadUpcomingAppointmentsFailure = createAction(
  '[Appointment] Load Upcoming Appointments Failure',
  props<{ error: string }>()
);

export const refreshUpcomingAppointments = createAction(
  '[Appointment] Refresh Upcoming Appointments'
);

